import React from 'react';
import { Section } from './ui/Section';
import { FadeIn } from './ui/FadeIn';
import { ArrowRight, ShieldCheck } from 'lucide-react';
import { trackAddToCart } from '../hooks/useMetaPixel';
export function PricingCTA() {
  return <Section id="pricing" className="bg-white pb-24" data-id="element-86">
      <FadeIn data-id="element-87">
        <div className="max-w-4xl mx-auto bg-[#2D2A26] rounded-3xl overflow-hidden shadow-2xl text-white" data-id="element-88">
          <div className="grid grid-cols-1 md:grid-cols-2" data-id="element-89">
            <div className="p-8 md:p-12 flex flex-col justify-center" data-id="element-90">
              <h2 className="text-3xl font-bold mb-4" data-id="element-91">Empieza hoy mismo</h2>
              <p className="text-gray-300 mb-8" data-id="element-92">
                Si hoy estás cansado de limpiar y seguir sintiendo pena, esto es
                lo que compra: un plan que no depende de tu fuerza de voluntad.
              </p>

              <div className="flex items-baseline gap-2 mb-2" data-id="element-93">
                <span className="text-5xl font-bold text-[#E8872B]" data-id="element-94">
                  US$6.39
                </span>
                <span className="text-gray-400" data-id="element-95">pago único</span>
              </div>
              <p className="text-sm text-gray-400 mb-8" data-id="element-96">
                Acceso inmediato al PDF + Bonos
              </p>

              <a href="https://krove.lat/cart/40640003670145:1" target="_blank" rel="noopener noreferrer" onClick={trackAddToCart} className="w-full bg-[#E8872B] hover:bg-[#d6761f] text-white font-bold py-4 px-6 rounded-lg shadow-lg transform transition hover:-translate-y-1 flex items-center justify-center gap-2 group" data-id="element-97">
                Descargar Protocolo 7 Días
                <ArrowRight className="group-hover:translate-x-1 transition-transform" data-id="element-98" />
              </a>

              <div className="mt-6 flex items-center gap-2 text-sm text-gray-400 justify-center md:justify-start" data-id="element-99">
                <ShieldCheck className="w-4 h-4" data-id="element-100" />
                <span data-id="element-101">Pago seguro y encriptado</span>
              </div>
            </div>

            <div className="bg-[#4A9BD9] p-8 md:p-12 flex items-center justify-center relative overflow-hidden" data-id="element-102">
              <div className="absolute inset-0 bg-[#E8872B] opacity-10 rounded-full transform scale-150 translate-x-1/2 translate-y-1/2" data-id="element-103"></div>
              <img src="https://cdn.magicpatterns.com/uploads/if9F5E5EWekxZCn4fRjKqw/heylloyd-image-1771191822676.png" alt="Casa Sin Olor Cover" className="relative z-10 rounded-lg shadow-2xl transform rotate-3 hover:rotate-0 transition-transform duration-500 max-w-[240px]" data-id="element-104" />
            </div>
          </div>
        </div>
      </FadeIn>
    </Section>;
}